import {Component, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {Apollo} from "apollo-angular";
import {sucursalesActivas} from "../../graphql/graphql.queris";
import {SucursalHorariosService} from "../../app-mkt/dashboard-mkt/sucursal-horarios/services/sucursal-horarios.service";
import {KeyValuePipe, NgForOf, NgOptimizedImage} from "@angular/common";


interface Sucursal {
  _id: string;
  ciudad: string;
  direccionSucursal: string;
  nameSucursal: string;
  linkMaps: string;
}


@Component({
  selector: 'app-footer-persona',
  standalone: true,
  imports: [
    RouterLink,
    NgForOf,
    KeyValuePipe,
    NgOptimizedImage
  ],
  templateUrl: './footer-persona.component.html',
  styleUrl: './footer-persona.component.css'
})
export class FooterPersonaComponent implements OnInit {
  sucursalesAgrupadas: {[ciudad: string]: Sucursal[]} = {};
  customSort: ((a: any, b: any) => number) | undefined;

  constructor(private sucursalHorariosService: SucursalHorariosService) {}

  ngOnInit(): void {
    try {
      this.sucursalHorariosService.getAllDataSucursalHorario()
  .subscribe((result: any) => {
    const sucursales = result.data.getAllDataHorarios;
    const ordenCiudades = ["Guayaquil", "Quito", "Babahoyo"];


    this.sucursalesAgrupadas = sucursales.reduce((acc: any, sucursal: any) => {
      const ciudad = sucursal.ciudad;

      if (!acc[ciudad]) {
        acc[ciudad] = [];
      }
      acc[ciudad].push(sucursal);

      return acc;
    }, {});


    // Creamos un nuevo objeto con las ciudades en el orden especificado
    const sucursalesOrdenadas: {[ciudad: string]: Sucursal[]} = {};
    ordenCiudades.forEach(ciudad => {
      if (this.sucursalesAgrupadas[ciudad]) {
        sucursalesOrdenadas[ciudad] = this.sucursalesAgrupadas[ciudad];
      }
    });
    this.sucursalesAgrupadas = sucursalesOrdenadas;


    this.customSort = (a: any, b: any) => {
      const ordenCiudades = ["Guayaquil", "Quito", "Babahoyo"];
      return ordenCiudades.indexOf(a.key) - ordenCiudades.indexOf(b.key);
    };
  });
      // console.log(this.sucursalesAgrupadas)
    } catch (error) {
      console.error(error);
    }
  }
}
